import React from 'react';
import './FloatingActions.scss';

const FloatingActions: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="floating-actions">{children}</div>
);

export default FloatingActions;
